import React, { useState, useEffect, useContext, useRef } from "react";
import { Fragment } from "react";
import { ReactReduxContext, useDispatch } from 'react-redux';
import { Route, Redirect, useHistory } from "react-router-dom";
import Footer from "../common/Footer";
import {
  POPUP_TYPES,

  REVIEW_LANDINGPAGE_LINK,
  REVIEW_ADDITIONAL_SECTIONS_LINK,
  REVIEW_HEADING_LINK,
  REVIEW_WORKHISTORY_LINK,
  REVIEW_EDUCATION_LINK,
  REVIEW_SKILLS_LINK,
  REVIEW_SUMMARY_LINK,
  DASHBOARD_LINK,
  COOKIE_DOMAIN,
} from '../../constants/constants';

import EditorHeading from '../EditorHeading';
//Core sections
import EditorWorkHistory from '../EditorWorkHistory';
import EditorEducationHistory from '../EditorEducationHistory';
import EditorSkills from '../EditorSkills';
import EditorSummary from '../EditorSummary';

// import ConfirmationBox from "./common/ConfirmationBox";
import WpAPI from "../../WpApi";

import AdditionalSections from "../AdditionalSections";
import { ResumeProvider, useResume } from "../../context/ResumeContext";
import '../../assets/scss/app/blocks/traditional-editor.scss';
//import { PopupProvider } from "../context/PopupContext";
//import Version from "../Version";
import { usePopup } from "../../context/PopupContext";
import Splash from "../common/Splash";
import ResumeReviewLayout from "./ResumeReviewLayout";
import ReviewLandingPage from "./ReviewLandingPage";
import { LeftSection } from "./LeftSection";
import { useUser } from "../../context/UserContext";
import Cookies from "js-cookie";
import { resumeReview } from "../../services/actions/actions";



const ResumeReview = (props) => {
  const { store } = useContext(ReactReduxContext);
  const popupbox = usePopup();
  const {
    checkMembership,
    plan,
  } = useUser();
  const dispatch = useDispatch()
  // const [showBack, setShowBack] = useState(false);
  const [showLoginPopUp, setShowLoginPopUp] = useState(false);
  // const [loader, setLoader] = useState(false);
  const [redirect2, setRedirect2] = useState();

  const [currentResume, setCurrentResume] = useState('');
  const { 
    handlers
  } = useResume();

  useEffect(() => {
    popupbox.configurePopup(POPUP_TYPES);
  }, []);

  // useEffect(() => {
  //   // if (props.resume.hasOwnProperty('created_date') && props.resume.enabled_tabs.length > 1 && !props.resume.created_date.length) setRedirect2(DASHBOARD_LINK)
    
  //   if (currentResume === '') {
  //     let cr = WpAPI.getCurrentResume();
  //     setCurrentResume(cr);
  //   }
    
  //       WpAPI.fetchActiveResume(dispatch, () => {
  //         let cr = WpAPI.getCurrentResume();
  //         setCurrentResume(cr);
  //         console.log(cr)
  //         // handlers.resumeReview();
  //       })


  // },[]);
  useEffect(() => {
    const cr = Cookies.get('current_resume', { domain: COOKIE_DOMAIN, path: '/' })
    //Not login/non pro/noninitialized cases will be redirected
   if( !WpAPI.isLoggedIn() || !cr) setRedirect2('/')
   else if(cr && !currentResume){//Load resume
        // This will run Only in case of reload
        WpAPI.fetchActiveResume(dispatch, () => {
          let cr = WpAPI.getCurrentResume();
          setCurrentResume(cr);
          dispatch(resumeReview());
          // handlers.resumeReview();
        })
   
  } 
  // else checkMembership((res) => {
  //       if(res?.plan !== 'pro' || !cr ) setRedirect2('/')
  //       else if(cr && !currentResume){//Load resume
  //         // This will run Only in case of reload
  //         WpAPI.fetchActiveResume(dispatch, () => {
  //           let cr = WpAPI.getCurrentResume();
  //           setCurrentResume(cr);
  //           dispatch(resumeReview());
  //           // handlers.resumeReview();
  //         })
  //       }
  //   })
}, []);

  if (redirect2) return <Redirect to={redirect2} />
  return (<>
    {props.currentResume != undefined && <ResumeProvider {...props}>
      <Fragment>
        <Route exact path={REVIEW_LANDINGPAGE_LINK} >
          <ReviewLandingPage />
        </Route>
        <Route exact path={REVIEW_ADDITIONAL_SECTIONS_LINK}>
          <ResumeReviewLayout
            left={<LeftSection section={{ name: "Additional", id: "additional_sections" }} />}
            right={<AdditionalSections splash={<Splash />} review={true} />}
            section={{ name: "Additional", id: "additional_sections" }}
          />
        </Route>
        <Route exact path={REVIEW_HEADING_LINK}>
          <ResumeReviewLayout
            right={<EditorHeading splash={<Splash />} review={true} />}
            left={<LeftSection section={{ name: "Personal Details", id: "personal_details" }} />}
            section={{ name: "Personal Details", id: "personal_details" }}
          />
        </Route>
        <Route exact path={REVIEW_WORKHISTORY_LINK}>
          <ResumeReviewLayout
            right={<EditorWorkHistory splash={<Splash />} review={true} />}
            left={<LeftSection section={{ name: "Professional Experience", id: "work_history", openedRowId: (sec) => sec?.edit_in_progress?.job }} />}
            section={{ name: "Professional Experience", id: "work_history" }}
          />
        </Route>
        <Route exact path={REVIEW_EDUCATION_LINK}>
          <ResumeReviewLayout
            right={<EditorEducationHistory splash={<Splash />} review={true} />}
            left={<LeftSection section={{ name: "Education", id: "education_history", openedRowId: (sec) => sec?.edit_in_progress?.education }} />}
            section={{ name: "Education", id: "education_history" }}
          />
        </Route>
        <Route exact path={REVIEW_SKILLS_LINK}>
          {/*  Layout is messed */}
          <ResumeReviewLayout
            right={<EditorSkills splash={<Splash />} review={true} />}
            left={<LeftSection section={{ name: "Skills", id: "skills" }} />}
            section={{ name: "Skills", id: "skills" }}
          />
        </Route>
        <Route exact path={REVIEW_SUMMARY_LINK}>
          {/*  Layout is messed */}
          <ResumeReviewLayout
            right={<EditorSummary splash={<Splash />} review={true} />}
            left={<LeftSection section={{ name: "Summary", id: "summary" }} />}
            section={{ name: "Summary", id: "summary" }}
          />
        </Route>
        <Footer className="edit-editor-footer" />
      </Fragment>
    </ResumeProvider>}
  </>);
};
export default ResumeReview;
